module.exports = __webpack_public_path__ + "img/oneBlue.d4e340d7.jpg";